// types
import { Article } from '../../../@types';

// router
import { Link as RouterLink } from 'react-router-dom';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box } from '@mui/material';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// ui
import { Html } from '../../ui/Html/Html';

// props
export interface DialogArticleProps extends DialogActionsProps {
	article: Article;
}

export const DialogArticle = ({
	article,
	isOpen = false,
	onClose,
	...props
}: DialogArticleProps) => {
	// hooks
	const { t } = useTranslation();

	return (
		<DialogActions
			actions={[
				{
					children: t('learnMore'),
					component: RouterLink,
					to: '/features',
					variant: 'text',
				},
				{
					children: t('gotIt'),
					onClick: onClose,
					variant: 'contained',
				},
			]}
			isOpen={isOpen}
			onClose={onClose}
			title={{ children: article.title }}
			{...props}>
			<>
				{article.img?.src && (
					<Box
						alt={article.img.alt}
						component="img"
						src={article.img.src}
						sx={{ borderRadius: 2, display: 'block', mb: 2, width: '100%' }}
					/>
				)}
				<Html html={article.intro} />
			</>
		</DialogActions>
	);
};
